<template>
    <div v-if="multiSectionList && multiSectionList.length && !isLoading" class="multi-section-wrap">
      <common-header title="LIVE" :is-back-btn="true" :back-fn="close" :is-close-btn="false"
                     :go-to-schedule-fn="goToSchedule" :go-to-reserve-watch-fn="goToReserveWatch"></common-header>
      <div v-for="sectionInfo in multiSectionList" :key="sectionInfo.title + 'live_container'" class="multi-section-container">
        <DynamicSectionLoader :section-info="sectionInfo" v-on-display="sectionInfo"></DynamicSectionLoader>
      </div>
    </div>
</template>
<script>
import DynamicSectionLoader from '@/components/section/DynamicSectionLoader'
import { onDisplay } from '@/common/directives'
import { enableBodyScroll } from '@/common/util/ui.utils'
import { commonErrorProcess, EventService } from '@/common/api/api.service'
import { get } from 'lodash'
import CommonHeader from '@/components/header/template/commonHeader'
import { GNBDataConverter } from '@/common/converter/ObjectConverter'
import { getEventListByType } from '@/common/util/event.util'
import EventModelClass from '@/common/model/EventModelClass'
import { buildGnbByUiCode } from '@/common/GnbBuilder'
import { MENU_LIVE_GN_CODE } from '@/common/menu/menu.const'
import { PATH_NAME_RESERVE_WATCH, PATH_NAME_SCHEDULE } from '@/common/router.const'

export default {
  name: 'Live',
  components: { CommonHeader, DynamicSectionLoader },
  directives: {
    onDisplay
  },
  data () {
    return {
      isLoading: true,
      multiSectionList: [],
      gnb: null
    }
  },
  methods: {
    close () {
      if (window.history.length < 3) {
        this.$router.push('/')
      } else {
        this.$router.back()
      }
    },
    goToSchedule () {
      this.$router.push({ name: PATH_NAME_SCHEDULE })
    },
    goToReserveWatch () {
      this.$router.push({
        name: PATH_NAME_RESERVE_WATCH,
        query: {
          referer: '/live'
        }
      })
    },
    setData () {
      this.isLoading = true
      const { onContentEvent } = getEventListByType(this.gnb.eventlist)
      EventService.requestEventData(new EventModelClass(onContentEvent)).then(({ data }) => {
        const gnb = GNBDataConverter(data)
        this.title = get(gnb, 'note', '')
        this.multiSectionList = get(gnb, 'multiSectionList', [])
        this.componentName = 'BandRouterView'
        this.isLoading = false
      }).catch(commonErrorProcess)
    }
  },
  created () {
    enableBodyScroll()
    this.gnb = buildGnbByUiCode(MENU_LIVE_GN_CODE)
    this.setData()
  }
}
</script>
